/**
 * PiHOT footer — sections/pihot-footer.liquid
 *
 * <p-footer-nav>  link columns: accordions below 768px, always-open columns above.
 * Columns render open, so without JS every link stays reachable.
 */
(() => {
  if (customElements.get('p-footer-nav')) return;

  const desktop = window.matchMedia('(min-width: 768px)');

  class PFooterNav extends HTMLElement {
    connectedCallback() {
      this.sync = () => {
        this.querySelectorAll(':scope > details').forEach((column) => {
          column.open = desktop.matches;
          column.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
        });
      };
      this.onClick = (event) => {
        if (desktop.matches && event.target.closest('summary')) event.preventDefault();
      };
      this.addEventListener('click', this.onClick);
      desktop.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      desktop.removeEventListener('change', this.sync);
    }
  }

  customElements.define('p-footer-nav', PFooterNav);
})();
